import { db } from '../firebase';
import firebase from '../firebase';

export const getChatConversations = async () => {
  const snapshot = await db.collection('support_chats').orderBy('lastMessageAt', 'desc').get();
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const getUnreadMessageCount = async () => {
  const snapshot = await db.collection('support_chats').where('unreadByAdmin', '==', true).get();
  return snapshot.size;
};

export const getChatMessages = async (userId) => {
  const snapshot = await db
    .collection('support_chats')
    .doc(userId)
    .collection('messages')
    .orderBy('createdAt', 'asc')
    .get();
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const sendAdminReply = async (userId, message, adminName = 'Support Team') => {
  const chatRef = db.collection('support_chats').doc(userId);

  await chatRef.collection('messages').add({
    senderId: 'admin',
    senderName: adminName,
    message,
    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
  });

  await chatRef.set({
    lastMessage: message,
    lastMessageAt: firebase.firestore.FieldValue.serverTimestamp(),
    unreadByAdmin: false,
    unreadByUser: true,
  }, { merge: true });
};

export const markConversationRead = async (userId) => {
  return db.collection('support_chats').doc(userId).update({
    unreadByAdmin: false,
  });
};
